import React, {RefObject} from 'react'

import NavigationSection from "../../../core/model2/navigation/navigation-section"
import VScroll from "../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import ErrorBoundary from "../../../core/error-boundary"
import VerticalResizeSeparator from "../../../core/gd-components/vertical-resize-separator/vertical-resize-separator"
// import MenuAsana from '../../ui/asana/menu-asana/menu-asana'

type Props = {
    refMenu     : RefObject<any>
    refScroll   : RefObject<VScroll>

    noAnimation : boolean
}

// const debug = "MainMenu_Static"
const debug = false

export default function MainMenu_Static(props:Props) {

    debug && console.brown(debug, "renderMenuStatic")

    const navigationSection : NavigationSection = gd.layout.navigation.state.currentSection!
    debug && console.log(debug, "render() STATIC sectionId=", navigationSection.id)

    const classes = Classes('ui-menu',{})

    // if (gd.layout.type === UIType.ASANA) {
    //     return <MenuAsana ref={props.refMenu} refScroll={props.refScroll} noAnimation={props.noAnimation}/>
    // }

    return (
        <div className={classes}>
            <ErrorBoundary>
                {/*key is important here as we want reset state when diff section*/}
                {navigationSection.menuComponent &&
                    <navigationSection.menuComponent key            = {navigationSection.id}
                                                     ref            = {props.refMenu}
                                                     refScroll      = {props.refScroll}
                                                     section        = {navigationSection}
                                                     noAnimation    = {props.noAnimation}/>
                }
                <VerticalResizeSeparator eventPrefix="menu" type='left' min={150} max={500}/>
            </ErrorBoundary>
        </div>
    );
}
